export function splitDescription(description, chunkSize = 400) {
  // Step 1: Remove special characters, emojis, and symbols
  const cleanedText = description
    ?.replace(/[^\w\s.,'-]/g, "") // remove most special characters and emojis
    ?.replace(/\s+/g, " ") // replace multiple spaces with a single space
    ?.trim();

  // Step 2: Split into sentences to better control chunking
  const sentences = cleanedText?.match(/[^.!?]+[.!?]*/g) || [cleanedText];

  // Step 3: Combine sentences into chunks
  const chunks = [];
  let currentChunk = "";

  for (let sentence of sentences) {
    if ((currentChunk + sentence).length <= chunkSize) {
      currentChunk += sentence + " ";
    } else {
      chunks.push(currentChunk.trim());
      currentChunk = sentence + " ";
    }
  }

  if (currentChunk.trim().length > 0) {
    chunks.push(currentChunk.trim());
  }

  return chunks;
}
